import React, {useEffect, useState} from 'react';
import EstimateTableItem from "../../../../components/UI/table/orders/organization/estimate/EstimateTableItem";
import {useNavigate} from "react-router-dom";
import ProductionCosts from "../../../../components/UI/table/orders/organization/estimate/ProductionCosts";
import CalculationTable from "../../../../components/UI/table/orders/organization/estimate/CalculationTable";
import JobMetricOrderOrganizationTable
    from "../../../../components/UI/table/orders/organization/estimate/JobMetricOrderOrganizationTable";
import MaterialEstimateUnitService from "../../../../API/orders/estimate/organization/MaterialEstimateUnitService";
import MaterialCostTable from "../../../../components/UI/table/orders/organization/estimate/MaterialCostTable";
import MenuItem from "@mui/material/MenuItem";
import {Button, TextField} from "@mui/material";
import {ButtonGroupTabBar} from "../../../../components/UI/button/ButtonGroupTabBar";
import CheckIcon from "@mui/icons-material/Check";
import Box from "@mui/material/Box";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import DetailUtil from "../../../../utils/cutting/DetailUtil";

const EstimateItem = ({
                          orderId,
                          orderNumber,
                          orderHeaderId,
                          year,
                          estimateId,
                          estimateState,
                          handleModalAlert,
                          isCloud,
                          isComposition
                      }) => {
    const profile = JSON.parse(localStorage.getItem("profile"))
    const [errorIds, setErrorIds] = useState({});
    const currency = [
        {tab: 1, type: "baseCurrency", value: profile?.baseCurAbbreviation},
        {tab: 2, type: "alternativeCurrency", value: profile?.alternativeCurAbbreviation}]
    const cost = [
        {tab: 1, value: "Расчетная"},
        {tab: 2, value: "Фактическая"}]

    const [currentEstimateState, setCurrentEstimateState] = useState()
    const [JobCalculationMetricOrderOrganization, setJobCalculationMetricOrderOrganization] = useState([]);
    const [JobWorkMetricOrderOrganization, setJobWorkMetricOrderOrganization] = useState([]);
    const [calculationData, setCalculationData] = useState([]);
    const [workData, setWorkData] = useState([]);
    const [productionCostsCalculation, setProductionCostsCalculation] = useState([]);
    const [productionCostsWork, setProductionCostsWork] = useState([]);
    const [tab, setTab] = useState(1);
    const [selectData, setSelectData] = useState({cost: 1, currency: 1})
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const savedTab = pagesData["/organization/orders"]?.tab
        savedTab && setTab(savedTab)
        const params = pagesData["/organization/orders"]?.params

        const selectedData = {...params, cost: estimateState === "CALCULATION" ? 1 : params?.cost}
        params && setSelectData(selectedData)

        getTabsData(savedTab, true)
    }
    const tableOptionsHandle = (nextState, currTab) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`/organization/orders+${tab}`, "tableOptions", nextState)
        }
    }

    const getTabsData = (tab, start) => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const tableOptions = pagesData[`/organization/orders+${tab}`]?.tableOptions

        let totalElements
        if (tab < 4) {
            selectData.cost === 1 ? totalElements = calculationData?.length : totalElements = workData?.length
        } else if (tab === 4 && selectData.cost === 1) {
            totalElements = productionCostsCalculation?.length
        } else if (tab === 4 && selectData.cost === 2) {
            totalElements = productionCostsWork?.length
        } else if (tab === 5 && selectData.cost === 1) {
            totalElements = JobCalculationMetricOrderOrganization?.length
        } else if (tab === 5 && selectData.cost === 2) {
            totalElements = JobWorkMetricOrderOrganization?.length
        }

        setTableOptions((prev) => ({
            ...prev,
            pageSize: tableOptions?.pageSize || 100,
            totalElements: start ? tableOptions?.totalElements : totalElements
        }))
    }
    const handleChangeTab = (tab) => {
        setTab(tab)
        getTabsData(tab)
        EditLocalStoragePagesData("/organization/orders", "tab", tab)
    }
    const handleChangeSelect = (type, tab) => {
        const newSelectData = {...selectData, [type]: tab}
        setSelectData(newSelectData)
        EditLocalStoragePagesData("/organization/orders", "params", newSelectData)
    }

    const calcData = (newData) => {
        const {calculation, others} = newData.reduce((acc, item) => {
            if (item.materialEstimateUnitState === 'CALCULATION') {
                acc.calculation.push(item);
            } else {
                acc.others.push(item);
            }
            return acc;
        }, {calculation: [], others: []});

        const error = {
            isCalc: DetailUtil.checkDuplicateNames(calculation),
            isFact: DetailUtil.checkDuplicateNames(others)
        };
        setErrorIds(error)

        setCalculationData(calculation.length > 0 ? calculation : []);
        setWorkData(others.length > 0 ? others : []);

        const calculationWithJobMetric = [];
        const prCostsCalculation = [];
        calculation.forEach(item => {
            let jobMetricOrderOrganizations = item.jobMetricOrderOrganizations;
            if (jobMetricOrderOrganizations) {
                calculationWithJobMetric.push(...item.jobMetricOrderOrganizations);
                jobMetricOrderOrganizations.forEach(item => {
                    let productionCosts = item.productionCosts
                    if (Array.isArray(productionCosts)) {
                        prCostsCalculation.push(...productionCosts);
                    }
                });
            }
        });
        const othersWithJobMetric = [];
        const prCostsWork = [];
        others.forEach(item => {
            let jobMetricOrderOrganizations = item.jobMetricOrderOrganizations;
            if (jobMetricOrderOrganizations) {
                othersWithJobMetric.push(...item.jobMetricOrderOrganizations);
                jobMetricOrderOrganizations.forEach(item => {
                    let productionCosts = item.productionCosts
                    if (Array.isArray(productionCosts)) {
                        prCostsWork.push(...productionCosts);
                    }
                });
            }
        });

        setJobCalculationMetricOrderOrganization(calculationWithJobMetric);
        setJobWorkMetricOrderOrganization(othersWithJobMetric)
        setProductionCostsCalculation(prCostsCalculation)
        setProductionCostsWork(prCostsWork);
    }
    const getData = () => {
        MaterialEstimateUnitService.getAllByOrderId(orderId)
            .then(function (response) {
                const fetchedData = response.data;
                calcData(fetchedData)
            })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }

    useEffect(() => {
        getStartPageSize()
        getData()
    }, [orderId]);

    const navigate = useNavigate();

    const redirectOrder = () => {
        navigate('/organization/orders/' + orderId + '/' + encodeURIComponent(orderNumber) + '/' + orderHeaderId + '/' + year);
    };

    const generalTabComponents = [
        {
            tabIndex: 1, label: "Итоги",
            component: <CalculationTable
                data={selectData.cost === 1 ? calculationData : workData}
                setData={selectData.cost === 1 ? setCalculationData : setWorkData}
                currency={currency}
                currentCurrency={selectData.currency}
                orderId={orderId}
                orderNumber={orderNumber}
                orderHeaderId={orderHeaderId}
                year={year}
                isActual={true}
                inWork={currentEstimateState === 'IN_WORK'}
                isFact={selectData.cost === 2}
                redirectOrder={redirectOrder}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
                errorIds={errorIds}
                handleModalAlert={handleModalAlert}
            />
        },
        {
            tabIndex: 2, label: "Себестоимость материалов",
            component: <EstimateTableItem
                data={selectData.cost === 1 ? calculationData : workData}
                setData={selectData.cost === 1 ? setCalculationData : setWorkData}
                currency={currency}
                currentCurrency={selectData.currency}
                orderId={orderId}
                orderNumber={orderNumber}
                orderHeaderId={orderHeaderId}
                year={year}
                isButtonPurchase={selectData.cost === 1}
                enableEditing={true}
                isActual={true}
                inWork={currentEstimateState === 'IN_WORK'}
                isCloud={isCloud}
                isComposition={isComposition}
                isFact={selectData.cost === 2}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
                estimateId={estimateId}
                estimateState={estimateState}
                selectData={selectData}
                handleModalAlert={handleModalAlert}
                getData={getData}
                calcData={calcData}
                errorIds={errorIds}
            />
        },
        {
            tabIndex: 3, label: "Стоимость материалов",
            component: <MaterialCostTable
                materialEstimateUnits={selectData.cost === 1 ? calculationData : workData}
                setMaterialEstimateUnits={selectData.cost === 1 ? setCalculationData : setWorkData}
                currency={currency}
                currentCurrency={selectData.currency}
                orderId={orderId}
                orderNumber={orderNumber}
                orderHeaderId={orderHeaderId}
                year={year}
                isButtonPurchase={true}
                enableEditing={true}
                isActual={true}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
            />
        },
        {
            tabIndex: 4, label: "Себестоимость работ",
            component: <ProductionCosts
                data={selectData.cost === 1 ? productionCostsCalculation : productionCostsWork}
                jobData={selectData.cost === 1 ? JobCalculationMetricOrderOrganization : JobWorkMetricOrderOrganization}
                setData={selectData.cost === 1 ? setProductionCostsCalculation : setProductionCostsWork}
                currency={currency}
                currentCurrency={selectData.currency}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
            />
        },
        {
            tabIndex: 5, label: "Стоимость работ",
            component: <JobMetricOrderOrganizationTable
                data={selectData.cost === 1 ? JobCalculationMetricOrderOrganization : JobWorkMetricOrderOrganization}
                setData={selectData.cost === 1 ? setJobCalculationMetricOrderOrganization : setJobWorkMetricOrderOrganization}
                forModal={selectData.cost === 1 ? calculationData : workData}
                orderId={orderId}
                currency={currency}
                currentCurrency={selectData.currency}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
                handleModalAlert={handleModalAlert}
            />
        },
    ];
    return (
        <>
            <ButtonGroupTabBar activeTab={tab}>
                {generalTabComponents.map(({tabIndex, label}, index) => (
                    <Button key={tabIndex} tabIndex={tabIndex} onClick={() => handleChangeTab(tabIndex)}>
                        <CheckIcon/>
                        {label}
                    </Button>
                ))}
            </ButtonGroupTabBar>
            <Box sx={{display: "flex", gap: "16px"}}>
                <TextField
                    sx={{width: "240px"}}
                    size="small"
                    select
                    label="Вид стоимости"
                    value={selectData.cost}
                    onChange={(e) => handleChangeSelect("cost", e.target.value)}
                >
                    {cost.map((option) => (
                        <MenuItem key={option.tab} value={option.tab}>
                            {option.value}
                        </MenuItem>))}
                </TextField>
                {tab === 1 && <TextField
                    sx={{width: "240px"}}
                    size="small"
                    select
                    label="Валюта"
                    value={selectData.currency}
                    onChange={(e) => handleChangeSelect("currency", e.target.value)}
                >
                    {currency.map((option) => (
                        <MenuItem key={option.tab} value={option.tab}>
                            {option.value}
                        </MenuItem>))}
                </TextField>}

            </Box>
            {generalTabComponents.find(component => component.tabIndex === tab)?.component}
        </>
    );
};

export default EstimateItem;